export const retrieveGames = () => {
  return JSON.parse(localStorage.getItem('pokerhost:games') || '[]');
}

export const storeGames = games => {
  localStorage.setItem('pokerhost:games', JSON.stringify(games));
}
